import React, { useCallback, useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import InputGroup from 'react-bootstrap/InputGroup'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import FuncFetch from '../../Utilities/funcFetch'
import { useMsal } from '@azure/msal-react'
import { AgGridReact } from 'ag-grid-react'
import { formatDate } from '../../Utilities/GridTools'
import './SearchForm.css'
import { Spinner } from 'react-bootstrap'
import CollectorClaimModal from '../ClaimModal/CollectorClaimModal'
import { AdvancedSearch } from './AdvancedSearch'
import { useLocation, useParams } from 'react-router-dom'

function SearchForm() {
    const { phone_number: routePhoneNumber } = useParams();
    const location = useLocation();
    const lowercaseParams = new URLSearchParams(
        Array.from(new URLSearchParams(location.search), ([key, value]) => [key.toLowerCase(), value])
    );
    const phoneNumberParam = routePhoneNumber
        ?? lowercaseParams.get('phonenumber')
        ?? lowercaseParams.get('phone_number');
    const [searchParam, setSearchParam] = useState('')
    const [searchLoading, setSearchLoading] = useState(false);
    const [selectedClaim, setSelectedClaim] = useState();
    const [showClaimModal, setShowClaimModal] = useState(false);
    const { instance, accounts } = useMsal();    
    const { REACT_APP_API_URL } = process.env;
    const [gridApi] = useState(null);
    const [defaultColDef] = useState({
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        width: 50,
      })
    const [columnDefs] = useState([
        {
            headerName: "Row",
            "field": "rowNumber"
        },
        {
            "field": "debtorId"
        },
        {
            "field": "clientName"
        },
        {
            "field": "debtorStatus"
        },
        {
            "field": "acctStatus"
        },
        {
            "field": "projectId"
        },
        {
            "field": "claimNumber"
        },
        {
            "field": "adjuster"
        },
        {
            "field": "listDate",
            "valueFormatter": formatDate,
            filter: 'agDateColumnFilter'
        },
        {
            "field": "dol",
            headerName: 'DOL',
            "valueFormatter": formatDate,
            filter: 'agDateColumnFilter'
        },
        {
            "field": "age"
        },
        {
            "field": "statusCode"
        },
        {
            "field": "statusDate",
            "valueFormatter": formatDate,
            filter: 'agDateColumnFilter'
        },
        {
            "field":"recoveryPercent",
            filter: 'agNumberColumnFilter'
        },
        {
            "field": "lastPtmAmt"
        },

        {
            "field": "lastPtmDt",
            "valueFormatter": formatDate,
            filter: 'agDateColumnFilter'
        }
      ])
    const [claims, setClaims] = useState([]);
    const [key, setKey] = useState();
    const inputRef = useRef(null);
    const buttonRef = useRef(null);
  
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Enter") {
          buttonRef.current.click();
        }
      };
  
      const inputElement = inputRef.current;
      inputElement.addEventListener("keypress", handleKeyPress);
  
      // Cleanup event listener on component unmount
      return () => {
        inputElement.removeEventListener("keypress", handleKeyPress);
      };
    }, []);

    useEffect(()=>{
        if(key){
            setClaims(null)
            setSearchParam('')
        }
    },[key])

        const clearFilters = useCallback(() => {
        if(gridApi){
            gridApi.setFilterModel(null);
        }
            }, [gridApi])

    const searchClaims = (e) => { 
        if(searchParam!==''){
            setSearchLoading(true)
            clearFilters()
            FuncFetch(`${REACT_APP_API_URL}/Claims/SearchClaims`,{search:searchParam},'POST',{},instance,accounts)
            .then(result=>{
                setSearchLoading(false)
                setClaims(result)
            })
            .catch(err=>{
                console.error('There was an issue, please try again.')
            })
        }
     }

    useEffect(() => {
        if (!phoneNumberParam) {
            return;
        }

        setSearchParam(phoneNumberParam);
        setSearchLoading(true);
        clearFilters();

        FuncFetch(
            `${REACT_APP_API_URL}/communications/FindPhoneNumbers`,
            { phonenumber: encodeURIComponent(phoneNumberParam) },
            'GET',
            null,
            instance,
            accounts
        )
            .then((result) => {
                const debtorId = result?.DebtorID;

                if (!debtorId) {
                    setClaims([]);
                    return null;
                }

                setSearchParam(debtorId);
                return FuncFetch(
                    `${REACT_APP_API_URL}/Claims/SearchClaims`,
                    { search: debtorId },
                    'POST',
                    {},
                    instance,
                    accounts
                );
            })
            .then((result) => {
                if (result) {
                    setClaims(result);
                }
            })
            .catch(() => {
                console.error('There was an issue, please try again.');
            })
            .finally(() => {
                setSearchLoading(false);
            });
    }, [phoneNumberParam, REACT_APP_API_URL, instance, accounts, clearFilters]);

    const onCellClicked = (e) => { 
        setSelectedClaim(e.data.debtorId);
        setShowClaimModal(true);
     }

    /* const onFirstDataRendered = (params) => {
        params.columnApi.autoSizeAllColumns();
        setGridApi(params.api);
    } */


  return (
    <>
    <CollectorClaimModal 
        show={showClaimModal} 
        setShow={setShowClaimModal} 
        selectedClaim={selectedClaim}
        setSelectedClaim={setSelectedClaim}
        claims={claims}
        />

    <h3>Claim Search</h3>
        <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            >
            <Tab eventKey="basic" title="Basic">
                <Row>
                    <Col>
                        <InputGroup>
                            <Form.Control ref={inputRef} placeholder='Search...' value={searchParam} onChange={(e)=>setSearchParam(e.target.value)} />
                            <Button ref={buttonRef} onClick={()=>searchClaims()}>
                                {searchLoading?
                                <Spinner animation='border' size='sm' />
                                :'Search'}
                            </Button>
                        </InputGroup>
                    </Col>
                </Row>
            </Tab>
            <Tab eventKey="advanced" title="Advanced">
                <AdvancedSearch setClaims={setClaims} clearFilters={clearFilters} />
            </Tab>
        </Tabs>
    {/* I keep claims defaulted to [] instead of null because AgGrid will show 'loading...' if it is null
        also if there are no search results returned, the api returns [null] so I have to check for that */}
    {(claims&&claims.length>0&&claims[0]!==null)?
        <Alert>{claims.length} Claims Found</Alert>
    :null}

    <div className="ag-theme-quartz compact-theme grid">
        <AgGridReact
            multiSortKey='ctrl'
            defaultColDef={defaultColDef}
            rowData={claims}
            columnDefs={columnDefs}
            onCellClicked={onCellClicked}
            onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
        ></AgGridReact>
    </div>
    </>
  )
}



export default SearchForm